import ServiceContainer from '@/shared/ServiceContainer/ServiceContainer';
import IServiceContainer from '@/shared/ServiceContainer/Contract/IServiceContainer';

export const getServiceContainer = (): IServiceContainer => new ServiceContainer();
